var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeypadLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 42,
    viewBox: "0 0 51 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2301 11.3387C26.2301 12.1744 25.5804 12.8241 24.7447 12.8241H18.3914C17.5557 12.8241 16.906 12.1744 16.906 11.3387V4.9854C16.906 4.14972 17.5557 3.5 18.3914 3.5H24.7447C25.5804 3.5 26.2301 4.14972 26.2301 4.9854V11.3387Z",
    fill: "white",
    stroke: "#121212"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.865 34.9695C12.865 36.4799 10.8846 37.0433 10.0896 35.759L1.4418 21.7895C1.14233 21.3058 1.14233 20.6942 1.4418 20.2105L10.0896 6.24096C10.8846 4.95672 12.865 5.52009 12.865 7.03049V34.9695Z",
    fill: "white",
    stroke: "#121212"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.865,
    y: 27.8242,
    width: 22,
    height: 9,
    rx: 1.5,
    fill: "white",
    stroke: "#121212"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.1331,
    y: 15.8242,
    width: 9,
    height: 9,
    rx: 1.5,
    fill: "white",
    stroke: "#121212"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 29.1331,
    y: 15.8242,
    width: 9,
    height: 9,
    rx: 1.5,
    fill: "white",
    stroke: "#121212"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 29.23,
    y: 3.5,
    width: 9,
    height: 9,
    rx: 1.5,
    fill: "white",
    stroke: "#121212"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 41.23,
    y: 3.5,
    width: 9,
    height: 9,
    rx: 1.5,
    fill: "white",
    stroke: "#121212"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 41.1331,
    y: 15.8242,
    width: 9,
    height: 9,
    rx: 1.5,
    fill: "white",
    stroke: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeypadLeft);
export default __webpack_public_path__ + "static/media/keypad_left.a648362a2f5788ab7ebe493008b1191e.svg";
export { ForwardRef as ReactComponent };